import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import './NavMenu.css';

export class NavMenu extends Component {
    displayName = NavMenu.name

    render() {
        return (
            <Navbar fluid className="mainnav" >
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="https://sla.ny.gov/">Liquor Authority </a>
                    </Navbar.Brand>
                </Navbar.Header>
            </Navbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js